export default function getValidationQuestionByElementType(
  elementType: string,
): boolean {
  switch (elementType) {
    case 'dropdown':
    case 'ranking':
    case 'radiogroup':
    case 'barrating':
    case 'ebemotionsratings':
    case 'funnyemotionsratings':
    case 'dortmunderemotionsratings':
    case 'rating':
    case 'ebslider':
    case 'ebsliderpolarity':
    case 'ebverticalpolarity':
    case 'comment':
    case 'text':
    case 'checkbox':
    case 'ebdragndrop':
      return true;
    default:
      return false;
  }
}
